import { useEffect, lazy, Suspense } from "react";
import { Spin } from "antd";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useSelector } from "react-redux";

//  api
import { api, useAxiosInterseptor } from "./api";
//  components
import AskToDeleteItem from "./components/modals/AskToDeleteItem";
import SuccessOperation from "./components/modals/SuccessOperation";
// pages
const Panel = lazy(() => import("./pages"));
const Login = lazy(() => import("./pages/Login"));

function App() {
  // useAxiosInterseptor();

  // variables
  const spinner = useSelector((state) => state.app.spinner);
  const helperModals = useSelector((state) => state.helperModals);

  return (
    <Suspense fallback={<Spin spinning size="large"></Spin>}>
      <Spin spinning={spinner} size="large">
        {helperModals.askToDelete && <AskToDeleteItem />}
        {helperModals.successText && <SuccessOperation />}
        <BrowserRouter>
          <Routes>
            <Route path="panel/*" element={<Panel />} />
            <Route path="login" element={<Login />} />

            {/*<Route path="article/*" element={<Article />} />
            <Route path="exam/*" element={<Exam />} />
            <Route path="classroom/*" element={<Classroom />} />*/}
          </Routes>
        </BrowserRouter>
      </Spin>
    </Suspense>
  );
}

export default App;
